<template>
<div id="login" class="loginbg">
    <v-content>
        <v-layout>
            <v-flex xs12>
                <a href="https://loadmax.com" > <img src="/static/loadmaxlogo.png" alt="LoadMax" height="40" class="lgImg"></a>
            </v-flex>
        </v-layout>
        <v-container fluid fill-height class="">
            <v-layout align-center justify-center>
                <v-flex xs12 sm8 md3 lg3 class="logintype-anchor">
                    <template v-if="loginType == imrUserStr">
                        <img src="/static/maxmarketing.png" alt="LoadMax" height="30" class="lgImg">
                    </template>
                    <v-card class="elevation-1 pa-3">
                        <v-card-text>
                            <div class="layout column ">
                                <h1 class="flex">Sign In</h1>
                            </div>
                            <v-form @submit="userLogin">
                                <v-text-field ref="email" autofocus v-validate="{required: 'login', email: true}" :error-messages="errors.collect('login')" name="login" label="Email" type="text" v-model="model.username"></v-text-field>
                                <v-text-field ref="password" autofocus v-validate="{required: 'password', min: 3}" :error-messages="errors.collect('password')" name="password" label="Password" id="password" type="password" v-model="model.password"></v-text-field>
                                <!-- <v-card-actions> -->
                                <v-btn type="submit" block color="orange darken-1 white--text"> SIGN IN</v-btn>

                                <v-layout>
                                    <v-flex md6 class="remember"> </v-flex>
                                    <v-flex md6 class="text-md-right ">
                                        <template v-if="loginType != imrUserStr">
                                            <router-link :to="{name:'ForgotPassword'}" class="links">Forgot Password?</router-link>
                                        </template>
                                        <template v-else-if="loginType == imrUserStr">
                                            <router-link to="/forgot-password/imr" class="links">Forgot Password?</router-link>
                                        </template>
                                    </v-flex>

                                </v-layout>
                                <!-- </v-card-actions> -->
                            </v-form>
                        </v-card-text>
                        <v-flex align-end class="signup" v-if="loginType != imrUserStr">
                            New to LOADMAX? <a href="https://loadmax.com/signup/" class="links"> Sign up now</a>
                        </v-flex>
                    </v-card>
                    <v-flex align-end class="text-md-center my-4 ">
                        <span class="calltxt">Questions? Call 1-866-925-6608</span>
                    </v-flex>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex";
import services from "../services/HttpService";
import utils from "../util/";
import moment from 'moment';
import config from '../config';
export default {
    data: () => ({
        model: {
            username: "",
            password: ""
        },
        loginType: "",
        imrUserStr: config.imrUserStr
    }),
    created() {
        const self = this;
        self.utils = utils;  
        if(self.$route.meta.type){
            self.loginType = self.$route.meta.type;
            if(self.loginType == config.imrUserStr){
                self.updateLoginType({
                    loginType:self.loginType
                })
            }
        }else{
            self.updateLoginType({
                loginType:null
            })
        }
    },
    mounted() {
        const self = this,
        wApp = window.getApp;
        //when session time out, redirect to login with loader
        wApp.$emit("showLoader", {
            show: false
        });
        
        setTimeout(function () {
            
        }, 100);
    },
    methods: {
        ...mapActions([
            "login",
            "updateLoginTimeStamp",
            "updateLoginType"
        ]),
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        
        userLogin(e) {
            e.preventDefault();
            const self = this,
                wApp = window.getApp;
            self.$validator
                .validateAll()
                .then(isValid => {
                    if (isValid) {
                        wApp.$emit("showLoader", {
                            show: true
                        });
                        services.post("users/login", {
                                "email": self.model.username,
                                "password": self.model.password
                            })
                            .then(res => {
                                wApp.$emit("showLoader", {
                                    show: false
                                });
                                if(self.loginType == '' && res.data.isImr && !res.data.Issuperadmin){
                                    self._showToast("Invalid Credentials!", 'red');
                                } else if(self.loginType == 'imr' && !res.data.isImr){
                                    self._showToast("Invalid Credentials!", 'red');
                                } else {
                                    const userData = Object.assign({}, res.data);
                                    if(userData.user_profile_pic==""){
                                        userData.user_profile_pic = config.defaultProfilePicPath;
                                    }
                                    delete userData.permissionSets;
                                    let loginTimeStamp = moment(new Date()).unix();
                                    userData.permissions = utils._getPermissionsMapping(res.data);
                                    self.updateLoginTimeStamp({
                                        loginTimeStamp: loginTimeStamp
                                    });
                                    self.login({
                                        user: userData
                                    });
                                    if (userData.status == "active") {
                                        self.$router.replace("/dashboard");
                                    } else {
                                        self.$router.replace("/disableduser");
                                    }
                                }                                
                            })
                            .catch(err => {
                                self._showToast(err.response && err.response.data.message ? err.response.data.message : err.message, 'red');
                                wApp.$emit("showLoader", {
                                    show: false
                                });
                            });
                    }
                })
                .catch(e => {
                    self._showToast(err.message, 'red');
                    wApp.$emit("showLoader", {
                        show: false
                    });
                });
        }
    }
};
</script>

<style lang="css" scoped>
#login {
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
    background-repeat: no-repeat;
    background-size: cover;
}
.md-input-has-placeholder input.ng-empty::-webkit-input-placeholder{ opacity: 0;}
.md-input-invalid input.ng-empty::-webkit-input-placeholder{ opacity: 1;}
.md-input-invalid label{ display: none;}
.md-input-focused label{ display: block;}
.md-input-invalid.md-input-focused input.ng-empty::-webkit-input-placeholder{ opacity: 0;}
.md-input-invalid input.ng-empty::-webkit-input-placeholder{ opacity: 1;}
.md-input-focused input::-moz-placeholder{  opacity: 0;}
@-moz-document url-prefix() { .md-input-has-placeholder label{ display: none;}}
.md-input-has-placeholder.md-input-focused label,.md-input-has-placeholder.md-input-has-value label{ display: block;}

md-input-container.md-input-focused ::-webkit-input-placeholder:not(.md-no-float),md-input-container.md-input-has-placeholder ::-webkit-input-placeholder:not(.md-no-float), md-input-container.md-input-has-value ::-webkit-input-placeholder:not(.md-no-float) {
    -webkit-transform: translate3d(0, 6px, 0) scale(0.75);
    transform: translate3d(0, 6px, 0) scale(0.75);}

md-input-container.md-input-focused label::-webkit-input-placeholder:not(.md-no-float), md-input-container.md-input-has-placeholder label::-webkit-input-placeholder:not(.md-no-float),md-input-container.md-input-has-value label::-webkit-input-placeholder:not(.md-no-float) {-webkit-transform: translate3d(0, 6px, 0) scale(0.75);
    transform: translate3d(0, 6px, 0) scale(0.75);}
.logintype-anchor{
    text-align:center !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue